const CONNECT_TOKEN = "RNADOM TEXT THAT NO ONE WILL EVERY GUESS"

export interface ModalButton {
    text: string;
    redirect?: string;
    style?: object;
    action?: 'close' | null;
}

export interface ModalConfig {
    title: string;
    content: string;
    buttons: ModalButton[];
    lock_page?: boolean;
}

export interface ModalConfigMsg {
    showModal: ModalConfig
}

export interface RedirectMsg {
    redirect: string;
}

export type EmbedMessage = ModalConfigMsg | RedirectMsg | { 'connect': string } | { 'scroll': number, data: string } | { 'params': Record<string, string> } | { 'getParams': true } | { 'myHeight': number } | { 'getScroll': string }

export class Embed {
    lastHeight = 0; //Set to 0 so that there will be an initial height sent to the parent
    static setup = false;
    static params: Record<string, string> | null = null;
    static connected = false;
    static onConnect: () => void = () => { };

    static async init(formName: string, onConnect: () => void) {
        Embed.onConnect = onConnect;
        if (!Embed.setup) {
            Embed.setup = true;

            //window.addEventListener("DOMContentLoaded", function () {
            //Check that server is good
            // fetch('/mc/checkStatus/' + formName, {
            //     method: "get"
            // }).then(data => {
            //     data.json().then(data => {
            //         if ('Error' in data) {
            //             $("#modal_errorMsg").html(data.Error)
            //             $('#errorModal').modal('show');
            //         }
            //     })
            // })
            // listen for messages from the parent.
            // TODO: verify that initial height has been received
            window.addEventListener("message", Embed.messageHandler, false);
            Embed.send({ 'connect': CONNECT_TOKEN })
            //Wait for Embed.connected to change to true
            while (!Embed.connected) {
                await new Promise(r => setTimeout(r, 100));
            }

            //Initiate the infinite loop
            Embed.sendHeight();
            Embed.send({ 'getParams': true })
            //}, false)
        }
    }

    static messageHandler(msg: MessageEvent) {
        if (msg.origin !== 'https://www.kingtechnology.com' && msg.origin !== 'https://www.frogproducts.com') {
            return;
        }
        if ('connect' in msg.data) {
            if (!Embed.connected && msg.data.connect == CONNECT_TOKEN) {
                Embed.connected = true;
                Embed.onConnect();
            }
        }
        if ('scroll' in msg.data) {
            // add a little padding
            const element = document.querySelector(msg.data.data);
            element.style.top = (msg.data.scroll + 15) + 'px';
        }
        if ('params' in msg.data) {
            console.log("Got Params:", msg.data.params)
            Embed.params = msg.data.params
            //console.log(msg.data.params.get('param1'))
        }
        //console.log("Inside:", msg)
        //origin = msg.origin
    }

    static async getParams(): Promise<typeof Embed.params> {
        //wait up to 5 seconds for params to be received
        let startTime = Date.now();
        while (Embed.params === null && Date.now() - startTime < 5000) {
            await new Promise(r => setTimeout(r, 100));
        }
        return Embed.params;
    }

    static send(data: EmbedMessage) {
        window.parent.postMessage(data, '*')
    }

    //Get position of an element relative to the top of the page (parent frame will respond with "scroll" message)
    static setParentScrollPos(modalID: string) {
        window.parent.postMessage({ "getScroll": `#${modalID}` }, '*')
    }

    static sendHeight() {
        parent.postMessage({ "myHeight": document.body.offsetHeight }, '*')
        setTimeout(Embed.sendHeight, 100);
    }
}